export type EmployerType = 'COMPANY' | 'EVENT';
export type AuthnMethod = 'LOCAL' | 'FEDERATED';
export type AdministratorType = 'GLOBAL' | 'PARTIAL' | 'NA';
export interface IEmployer {
  id: string;
  siren: string;
  name: string;
  tag: string;
  ou: string;
  employer_type: EmployerType;
  authn_method: AuthnMethod;
  api_organization_id: string;
}

export interface IEmployee {
  id: string;
  uid: string;
  sn: string;
  given_name: string;
  email_address: string;
  mobile: string;
  federation_id: string;
  business_domain: string;
  operational_seller_number_list: string[];
  administrator_type: AdministratorType;
  administrative_seller_number_list: string[];
  last_login_time: Date;
  account_status?: AccountStatus;
  mfa_capable: boolean;
  teaching_account: boolean;
  supervisor: boolean;
  supervised: boolean;
  fin_ent: string;
  employer: string;
}

export interface INumeroAgrement {
  bnppf_pos_id: string;
  business_domain: string;
  employer: string;
  id: string;
  name: string;
  partner_pos_id: string;
}
export interface IRetail {
  libelle: string;
  pos_id: string;
}

export interface Societe {
  label: string;
  value: string;
  siren: string;
}

export type ShortPdv = Pick<
  INumeroAgrement,
  'bnppf_pos_id' | 'name' | 'partner_pos_id'
>;

export interface ISelectNumeroAgrement extends ShortPdv {
  added: boolean;
}

export interface IdToken {
  account_status: string;
  administrative_seller_number_list: [];
  administrator_type: string;
  aud: string;
  auth_time: string;
  employer: string;
  exp: string;
  family_name: string;
  fin_ent: string;
  given_name: string;
  iat: string;
  iss: string;
  jti: string;
  last_login: string;
  mfa_capable: string;
  sub: string;
  habilitations?: [
    {
      ou: string;
      libelle: string;
      roles: [
        {
          cn: string;
          libelle: string;
        }
      ];
    }
  ];
}

export interface FormInput {
  value: string;
  error_msg: string;
}

export interface ScimError {
  error: string;
  error_description: string;
}

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  DISABLED_PARTNER = 'DISABLED_PARTNER',
  DISABLED_BNPPF = 'DISABLED_BNPPF',
}

export enum FileState {
  DEFAULT = 'default',
  LOADING = 'loading',
  FILLED = 'filled',
  ERROR = 'error',
}

export type IFile = { file: File; state: FileState; error: string };

export enum APIMessage {
  OK = 'OK',
  UNIQUENESS = 'UNIQUENESS',
  AUTHORIZATION = 'AUTHORIZATION',
  ERROR = 'error',
}

export type ImportResponse = {
  uid: string;
  message: APIMessage;
  description: string;
  user_password: string;
};

export type ImportPdvResponse = {
  id?: string;
  message: APIMessage;
  description?: string;
  bnppf_pos_id?: string;
  point_of_sale?: {
    bnppf_pos_id: string;
    name: string;
    partner_pos_id: string;
  };
};

export type QueryReturnValue<T = unknown, E = unknown, M = unknown> =
  | {
      error: E;
      data?: undefined;
      meta?: M;
    }
  | {
      error?: undefined;
      data: T;
      meta?: M;
    };
